import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import moment from 'moment';
import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";
import { formatDate } from "../../../../utils/dateUtils";

function ListadoVentasTiendas() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_VENTAS_TIENDAS = import.meta.env.VITE_URL_VENTAS_TIENDAS;
  const URL_ABONOS_TIENDAS = import.meta.env.VITE_URL_ABONOS_TIENDAS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_VENTAS_TIENDAS = import.meta.env.VITE_URL_ARTICULOS_VENTAS_TIENDAS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;

  let date = new Date()
  let hoy = moment(date).format("YYYY-MM-DD"); 

  const [ventasTiendas, setVentasTiendas] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [paqueteria, setPaqueteria] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(hoy);
  const [selectedFechaFin, setSelectedFechaFin] = useState(hoy);
  const [fecha, setFecha] = useState("");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [iva, setIva] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  
  const [areas, setAreas] = useState([]);
  const [selectedAreaFiltro, setSelectedAreaFiltro] = useState("");
  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transferencia, setTransferencia] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");


  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(()=>{
    setSelectedArea(user.areas)
    if(user.areas){
    if(user.areaEsTienda == "Si" ){
    axios
      .get(`${URL_VENTAS_TIENDAS}VentasDiario/${user.areas}/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        // Array para pagination
        let arrayTabla = allVentas
          .sort((a, b) => (a.idVentaTienda > b.idVentaTienda ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idVentaTienda,
              consecutivo: a.prefijo + "-" + a.consecutivo,
              activo: a.is_active,
              fecha: a.fecha,
              // Dia en que el apartado se liquido y entrego. Vacio en las
              // ventas normales y en los apartados anteriores al campo.
              fechaLiquidacion: a.fechaLiquidacion || "",
              // Con esta fecha hay que filtrar en pantalla, no con `fecha`.
              // El backend (filtroVentasFinalizadas) ya cuenta los apartados
              // en el dia que se liquidaron; al volver a filtrar aqui por la
              // fecha de creacion, un apartado abierto una semana y cerrado
              // la siguiente se caia de las DOS: de la de cierre lo tiraba
              // esta pantalla, y de la de apertura no lo mandaba el backend.
              fechaEfectiva: a.fechaLiquidacion || a.fecha,
              fechaHora: a.fecha + " " + moment(a.createdAt).utcOffset('-0600').format("HH:mm:ss"),
              colaborador: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
              idColaborador: a.colaboradores[0]._id,
              observaciones: a.observaciones,
              subTotal: a.subTotal,
              iva: a.iva,
              total_general: a.total_general,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              total_cantidad: a.total_cantidad,
              comisionTDC: a.comisionTDC,
              comisionFlete: a.comisionFlete,
              impuestos: a.impuestos,
              calle: a.clientes[0].calle,
              numero_ext: a.clientes[0].numero_ext,
              numero_int: a.clientes[0].numero_int,
              pais: a.clientes[0].pais,
              estado: a.clientes[0].estado,
              ciudad: a.clientes[0].ciudad,
              delegacion: a.clientes[0].delegacion,
              colonia: a.clientes[0].colonia,
              cp: a.clientes[0].cp,
              paqueteria: a.clientes[0].paqueteria,
              idAreas: a.areas[0]._id,
              area: a.areas[0].name,
              areaSurtido: a.areaSurtido[0].name,
              condPago: a.cond_pago,
              entregado:a.entregado,
              descuento:a.descuento,
              descuentoTipo: a.descuentoTipo || "%",
              descuentoNumero: a.descuentoNumero != null ? a.descuentoNumero : (parseFloat(a.subTotal) * parseFloat(a.descuento))/100,
              facturado:a.facturado,
              numeroFactura: a.facturado === "Si" && a.facturas && a.facturas[0]
                ? `${a.facturas[0].serie || ""}${a.facturas[0].folio || ""}`
                : "No",
              cajaNombre: a.caja?.[0]?.nombre || "—",
              cajero: a.user && a.user[0] ? a.user[0].nombre + " " + a.user[0].apellido : "—",
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        setVentasTiendas(data);
        setComments(data);
        //
      })
      .catch((err) => {
        console.log(err);
      })} else{
        axios
          .get(`${URL_VENTAS_TIENDAS}VentasDiarioGeneral/${selectedFechaInicio}/${selectedFechaFin}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((response) => {
            let allVentas = response.data;
            // Array para pagination
            let arrayTabla = allVentas
              .sort((a, b) => (a.idVentaTienda > b.idVentaTienda ? 1 : -1))
              .map((a) => {
                return {
                  _id: a._id,
                  numero: a.idVentaTienda,
                  consecutivo: a.prefijo + "-" + a.consecutivo,
                  activo: a.is_active,
                  fecha: a.fecha,
                  // Mismo criterio que en la consulta por tienda, arriba.
                  fechaLiquidacion: a.fechaLiquidacion || "",
                  fechaEfectiva: a.fechaLiquidacion || a.fecha,
                  fechaHora: a.fecha + " " + moment(a.createdAt).utcOffset('-0600').format("HH:mm:ss"),
                  colaborador: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
                  idColaborador: a.colaboradores[0]._id,
                  observaciones: a.observaciones,
                  subTotal: a.subTotal,
                  iva: a.iva,
                  total_general: a.total_general,
                  clientes: a.clientes[0].nombre_comercial,
                  idClientes: a.clientes[0]._id,
                  total_cantidad: a.total_cantidad,
                  comisionTDC: a.comisionTDC,
                  comisionFlete: a.comisionFlete,
                  impuestos: a.impuestos,
                  calle: a.clientes[0].calle,
                  numero_ext: a.clientes[0].numero_ext,
                  numero_int: a.clientes[0].numero_int,
                  pais: a.clientes[0].pais,
                  estado: a.clientes[0].estado,
                  ciudad: a.clientes[0].ciudad,
                  delegacion: a.clientes[0].delegacion,
                  colonia: a.clientes[0].colonia,
                  cp: a.clientes[0].cp,
                  paqueteria: a.paqueterias[0]?.name || "",
                  idPaqueteria: a.paqueterias[0]?._id || "",
                  idAreas: a.areas[0]._id,
                  area: a.areas[0].name,
                  areaSurtido: a.areaSurtido[0].name,
                  condPago: a.cond_pago,
                  entregado:a.entregado,
                  descuento:a.descuento,
                  descuentoTipo: a.descuentoTipo || "%",
                  descuentoNumero: a.descuentoNumero != null ? a.descuentoNumero : (parseFloat(a.subTotal) * parseFloat(a.descuento))/100,
              facturado:a.facturado,
              numeroFactura: a.facturado === "Si" && a.facturas && a.facturas[0]
                ? `${a.facturas[0].serie || ""}${a.facturas[0].folio || ""}`
                : "No",
              cajaNombre: a.caja?.[0]?.nombre || "—",
              cajero: a.user && a.user[0] ? a.user[0].nombre + " " + a.user[0].apellido : "—",
                }
              })
              .filter(function (el) {
                return el != null;
              });

            let data = Object.values(arrayTabla);

            setVentasTiendas(data);
            setComments(data);
            //
          })
          .catch((err) => {
            console.log(err);
          })}
        }

          axios
          .get(URL_AREAS, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allAreas = res.data;
            setAreas(allAreas);
          })
          .catch((err) => {
            console.log(err);
          });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [user, selectedFechaInicio, selectedFechaFin]);


  function PDFTabla() {
    let TotalTabla = 0
    let TotalPiezas = 0
    const data = comments.map((a) => {
      if (
        // Por fechaEfectiva, igual que la tabla: si no, el PDF y el Excel
        // siguen perdiendo los apartados liquidados en otra semana.
        (selectedFechaInicio == 0 || selectedFechaInicio <= (a.fechaEfectiva || a.fecha)) &&
        (selectedFechaFin == 0 || selectedFechaFin >= (a.fechaEfectiva || a.fecha)) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idColaborador)&&
        (selectedAreaFiltro == 0 || selectedAreaFiltro == a.idAreas)
      ) {
        TotalTabla = TotalTabla + a.total_general
        TotalPiezas = TotalPiezas + a.total_cantidad
        return [
          a.consecutivo,
          a.area,
          a.fecha,
          a.fechaLiquidacion,
          a.colaborador,
          a.clientes,
          a.total_cantidad,
          a.condPago,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 155, 15, 25, 25);

    doc.setFontSize(14)
    doc.text(`Listado Ventas`, 15, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 15, 35);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Area",
          "Fecha",
          "Liquidado",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Cond Pago",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(TotalPiezas),
          "",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(TotalTabla),
        ]
      ],
      showFoot: "lastPage",
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        // Por fechaEfectiva, igual que la tabla: si no, el PDF y el Excel
        // siguen perdiendo los apartados liquidados en otra semana.
        (selectedFechaInicio == 0 || selectedFechaInicio <= (a.fechaEfectiva || a.fecha)) &&
        (selectedFechaFin == 0 || selectedFechaFin >= (a.fechaEfectiva || a.fecha)) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idColaborador)&&
        (selectedAreaFiltro == 0 || selectedAreaFiltro == a.idAreas)
      ) {
        return {
          Numero: a.consecutivo,
          Area: a.area,
          Fecha: a.fecha,
          Liquidado: a.fechaLiquidacion,
          Vendedor: a.colaborador,
          Cliente: a.clientes,
          Cantidad: a.total_cantidad,
          CondPago: a.condPago,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoVentas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoVentas",
        sheetFilter: [
          "Numero",
          "Area",
          "Fecha",
          "Liquidado",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "CondPago",
          "Total",
        ],
        sheetHeader: [
          "Numero",
          "Area",
          "Fecha",
          "Liquidado",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "CondPago",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let TotalTabla = 0
    let TotalPiezas = 0
    const data = comments.map((a) => {
      if (
        // Por fechaEfectiva, igual que la tabla: si no, el PDF y el Excel
        // siguen perdiendo los apartados liquidados en otra semana.
        (selectedFechaInicio == 0 || selectedFechaInicio <= (a.fechaEfectiva || a.fecha)) &&
        (selectedFechaFin == 0 || selectedFechaFin >= (a.fechaEfectiva || a.fecha)) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idColaborador)&&
        (selectedAreaFiltro == 0 || selectedAreaFiltro == a.idAreas)
      ) {
        TotalTabla = TotalTabla + a.total_general
        TotalPiezas = TotalPiezas + a.total_cantidad
        return [
          a.consecutivo,
          a.area,
          a.fecha,
          a.fechaLiquidacion,
          a.colaborador,
          a.clientes,
          a.total_cantidad,
          a.condPago,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape","mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Ventas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Area",
          "Fecha",
          "Liquidado",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Cond Pago",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(TotalPiezas),
          "",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(TotalTabla),
        ]
      ]
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ventas",
          email: mailTo,
          fileName: "ListadoVentas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ventas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

 

  async function PDFOC(
    fecha,
    fechaHora,
    colaborador,
    clientes,
    consecutivo,
    idPDFOC,
    comisionTDC,
    comisionFlete,
    impuestos,
    areaSurtido,
    descuento,
    descuentoNumero,
    condPago,
    idAreas,
    subTotalDB,
    ivaDB,
    totalGeneralDB,
    descuentoTipo,
    cajero,
    cajaNombre,
  ) {
    await axios
      .get(`${URL_ARTICULOS_VENTAS_TIENDAS}/ventasTiendas/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosVenta = response.data;
        let arrayTabla = allArticulosVenta
          .map((a) => {
            return {
              idArticulo: a.articulos[0]._id,
              articulos: a.articulos[0].codigo + " - " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              precio: a.precio,
              total: a.total,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
              tallaNombre: a.tallas && a.tallas[0] ? a.tallas[0].name : "",
              colorNombre: a.colores && a.colores[0] ? a.colores[0].name : "",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            articulos: item.articulos,
            precio: item.precio,
            cantidad: 0,
            total: 0,
            cajas: 0,
            lineas: [],
          };
          groups[val].cantidad += item.cantidad;
          groups[val].total += item.total;
          groups[val].cajas += item.cajas;
          // Consolida por color+talla: si la misma talla/color ya existe en el
          // desglose, suma su cantidad y total en lugar de crear otro renglón.
          const tallaNombre = item.tallaNombre || "";
          const colorNombre = item.colorNombre || "";
          const lineaExistente = groups[val].lineas.find(
            (l) => l.tallaNombre === tallaNombre && l.colorNombre === colorNombre
          );
          if (lineaExistente) {
            lineaExistente.cantidad += item.cantidad;
            lineaExistente.total += item.total;
          } else {
            groups[val].lineas.push({
              tallaNombre,
              colorNombre,
              cantidad: item.cantidad,
              precio: item.precio,
              total: item.total,
            });
          }
          return groups;
        }, []);

        let dataAgrupado = Object.values(agrupado);

        // Jalamos Abonos
        axios
      .get(`${URL_ABONOS_TIENDAS}/ventasTiendas/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAbonosVenta = response.data;
        let arrayTablaAbonos = allAbonosVenta
          .map((a) => {
            return {
              efectivo: a.efectivo,
              tdc: a.tdc,
              transfer: a.transfer,
              deposito: a.deposito || 0,
              cheque: a.cheque || 0,
              numeroCheque: a.numeroCheque || "NA",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinalAbonos = Object.values(arrayTablaAbonos);
        const hasDeposito = dataFinalAbonos.some((a) => a.deposito > 0);
        const hasCheque = dataFinalAbonos.some((a) => a.cheque > 0);
        const dataAbonos = dataFinalAbonos
        .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
        .map((a) => {
          const row = [
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.efectivo),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.tdc),
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.transfer),
          ];
          if (hasDeposito) row.push(new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.deposito));
          if (hasCheque) row.push(new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cheque), a.numeroCheque);
          return row;
        });
        const dataPDFAbonos = Object.values(dataAbonos);
        const dataPDFAbonosLimpia = dataPDFAbonos.filter(function (el) {
          return el != null;
        });
// Terminamos Abonos

        let totalKG = dataAgrupado.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);

        let cajas = dataAgrupado.map((c) => parseFloat(c.cajas));
        let TC = cajas.reduce((t, total, index) => t + total, 0);

        let LA = dataFinal.length * 1.5
        let largoTotal = LA + 4 + 13 + 13

        let total_general_tabla = 0
        let iva_tabla = 0

        const data = dataAgrupado
        .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
        .flatMap((a) => [
          [{ content: a.articulos, colSpan: 3, styles: { fontStyle: "bold", halign: "left", cellPadding: { top: 0.1, bottom: 0, left: 0.1, right: 0.1 } } }],
          ...a.lineas.map((l) => [
            { content: `   ${new Intl.NumberFormat("en-US").format(l.cantidad)} x  ${l.colorNombre} / ${l.tallaNombre}`, colSpan: 3, styles: { halign: "left", fontStyle: "bold", fontSize: 8, cellPadding: { top: 0.05, bottom: 0.05, left: 0.2, right: 0.1 } } },
          ]),
          [
            { content: `Cant: ${new Intl.NumberFormat("en-US").format(a.cantidad)}`, styles: { halign: "left", cellPadding: { top: 0, bottom: 0.1, left: 0.1, right: 0.1 } } },
            { content: `Precio: ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.precio)}`, styles: { halign: "left", cellPadding: { top: 0, bottom: 0.1, left: 0.1, right: 0.1 } } },
            { content: `Total: ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.total)}`, styles: { halign: "right", cellPadding: { top: 0, bottom: 0.1, left: 0.1, right: 0.1 } } },
          ],
        ]);
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });

        // Usar valores guardados en BD para evitar recalcular con IVA hardcodeado
        let subTotalSinIva = parseFloat(subTotalDB) || 0;
        let descuentoMontoTabla = parseFloat(descuentoNumero) || 0;
        iva_tabla = parseFloat(ivaDB) || 0;
        total_general_tabla = parseFloat(totalGeneralDB) || 0;

        // Medir alto real con docTemp para evitar cortes o páginas extra
        const doc = new jsPDF("p", "cm", [8, largoTotal], true);
        var base64 = qrcode.toDataURL(idPDFOC);
        var img3 = new Image();
        img3.src = base64;

        var img2 = new Image();
        img2.src = "logoInstitucion.png";
        
        doc.addImage(img2, "png", 5,1,2,2);

        doc.setFontSize(6).setFont(undefined, 'bold')
        doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, 0.3, 1);
        doc.text(`Sucursal: ${user.areaName}`, 0.3, 1.3);
        doc.text(`Direccion:${user.areaDireccion}`, 0.3, 1.6);
        doc.text(`Atencion al Cliente: ${user.areaTelefono}`, 0.3, 1.9);


        doc.text(`Fecha: ${fechaHora}`, .3, 2.5);
        doc.text(`Nota: ${consecutivo} / Almacen: ${areaSurtido} / Caja: ${cajaNombre || "—"}`,0.3, 2.8 );
        doc.text(`Piezas: ${new Intl.NumberFormat("en-US").format(TK)} / Cajas ${TC.toFixed(2)}`,0.3, 3.1);
        doc.text(`Cliente: ${clientes}`, .3, 3.4);
        doc.text(`Vendedor: ${colaborador}`, 0.3, 3.7);
        doc.text(`Cajero: ${cajero || "—"}`, 0.3, 4.0);

        doc.autoTable({
          head: [[{ content: "Articulos", colSpan: 3, styles: { halign: "left" } }]],
          body: dataPDFLimpia,
          styles: { fontSize: 8, overflow: "linebreak" },
          columnStyles: { 0: { cellWidth: 2.4 }, 1: { cellWidth: 2.4 }, 2: { cellWidth: 2.5 } },
          startY: 4.3,
          theme: "plain",
          margin: { left: 0.3, right: 0.3 },
          foot: [
            [{ content: "Total Cajas", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US").format(TC)],
            [{ content: "Total Piezas", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US").format(TK)],
            [{ content: "SubTotal s/IVA", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(subTotalSinIva)],
            [{ content: `Descuento ${(descuentoTipo || "%") === "$" ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(descuentoMontoTabla) : `${descuento}%`}`, colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(descuentoMontoTabla)],
            [{ content: "IVA (16%)", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(iva_tabla)],
            [{ content: "Comision TDC", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(comisionTDC)],
            [{ content: "Flete", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(comisionFlete)],
            [{ content: "Total", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(total_general_tabla)],
          ],
          showFoot: "lastPage",
        });

        doc.autoTable({
          head: [
            [
              "Efectivo",
              "TDC",
              "Transfer",
              ...(hasDeposito ? ["Depósito"] : []),
              ...(hasCheque ? ["Cheque", "No. Cheque"] : []),
            ],
          ],
          body: dataPDFAbonosLimpia,
          styles: {
            fontSize: 8,
          },
          startY: doc.autoTable.previous.finalY + .5,
          theme:"plain",
          margin:{left:0.3, right:0.7},
        })

      if(condPago == "Credito"){
        doc.text(`Firma: ________________`, 0.3, doc.autoTable.previous.finalY + .7);
      }

      let leyendaY = doc.autoTable.previous.finalY + (condPago == "Credito" ? 1.2 : .7);
      doc.setFontSize(7);
      doc.text(
        "CAMBIOS POR MODELO ANTES DE LOS 15 DÍAS HABIENDO EXISTENCIA.",
        doc.internal.pageSize.getWidth() / 2,
        leyendaY,
        { align: "center", maxWidth: doc.internal.pageSize.getWidth() - 0.6 }
      );

        window.open(doc.output("bloburl"), "_blank");
      })
        .catch((err) => {
          console.log(err);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }



  const headers = [
    // { name: "Activo", field: "activo", sortable: true },
    { name: "Numero", field: "consecutivo", sortable: true },
    { name: "General", field: "numero", sortable: true },
    { name: "Tienda", field: "area", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    // Dia en que se liquido el apartado, que es el periodo en el que el
    // reporte lo cuenta. Se muestra aparte de "Fecha" para poder cotejar
    // contra los tickets sin confundir la apertura con el cierre; en una
    // venta normal va vacia.
    { name: "Liquidado", field: "fechaLiquidacion", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "colaborador", sortable: true },
    { name: "Cajero", field: "cajero", sortable: true },
    { name: "Cantidad", field: "total_cantidad", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Cond Pago", field: "condPago", sortable: true },
    { name: "Facturado", field: "numeroFactura", sortable: true },
    { name: "Caja", field: "cajaNombre", sortable: true },
    { name: "Recibo", field: "recibo", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.facturado.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_cantidad.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.consecutivo.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.condPago.toLowerCase().includes(search.toLowerCase()) 
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idColaborador.includes(selectedColaborador)
      );
    }

    // Contra fechaEfectiva, no contra fecha: ver el comentario del mapeo.
    // Con `fecha` los apartados liquidados en otra semana desaparecian del
    // reporte, y con ellos la comision de quien los vendio.
    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => (e.fechaEfectiva || e.fecha) >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => (e.fechaEfectiva || e.fecha) <= selectedFechaFin
      );
    }
    if (selectedAreaFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idAreas.includes(selectedAreaFiltro)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedColaborador,
    selectedFechaInicio,
    selectedFechaFin,
    selectedAreaFiltro
  ]);

  function cancelarNota(idNota) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara la Nota!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
    axios
      .get(`${URL_VENTAS_TIENDAS}Cancel/${idNota}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
        setComments(prev => prev.map(v => v._id === idNota ? { ...v, activo: "No" } : v));
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
    }
  });
  }

    function desarrollo(){
      axios
        .get(
          `${URL_ARTICULOS_VENTAS_TIENDAS}Analisis`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )      
        .then((res) => {
         let array = res.data

            let dataExcel = array.map((a) => {
            if(a.diferencia != 0 && a.ventaActiva == "Si"){
                return {
                  Numero: a.numero,
                  Fecha: a.fecha,
                  Id: a.id,
                  Total: a.total,
                  Cantidad: a.cantidad,
                  Diferencia: a.diferencia,
                  VentaActiva: a.ventaActiva
                };}
            });
            const dataExportExcel = Object.values(dataExcel);
            const dataExcelLimpia = dataExportExcel.filter(function (el) {
              return el != null;
            });
        
            var option = {};
        
            option.fileName = "ListadoVentas";
        
            option.datas = [
              {
                sheetData: dataExcelLimpia,
                sheetName: "ListadoVentas",
                sheetFilter: [
                  "Numero",
                  "Fecha",
                  "Id",
                  "Total",
                  "Cantidad",
                  "Diferencia",
                  "VentaActiva",
                ],
                sheetHeader: [
                  "Numero",
                  "Fecha",
                  "Id",
                  "Total",
                  "Cantidad",
                  "Diferencia",
                  "VentaActiva",
                ],
              },
            ];
        
            var toExcel = new ExportJsonExcel(option);
            toExcel.saveExcel();
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
          });
          console.log(error);
        });
  }
  let totalCant = 0
  let totalGen = 0

  return (
    <>
      <Header />
      <br />
      <br />
      {user.listadoVentasTiendas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.ventasTiendas ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/VentasTiendasCreate"
                >
                  Nuevo Venta
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Venta
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuTiendas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  // onClick={desarrollo}
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ventas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Reporte de Ventas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>

          
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedAreaFiltro}
                onChange={(e) => {
                  setSelectedAreaFiltro(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
              </td>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedColaborador}
                onChange={(e) => {
                  setSelectedColaborador(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                  if(a.activo == "Si"){
                    totalCant = totalCant + a.total_cantidad
                    totalGen = totalGen + a.total_general
                  return (
                    <tr>
                      {/* <td>{a.activo}</td> */}
                      <td>{a.consecutivo}</td>
                      <td>{a.numero}</td>
                      <td>{a.area}</td>
                      <td>{formatDate(a.fecha)}</td>
                      <td>{a.fechaLiquidacion ? formatDate(a.fechaLiquidacion) : ""}</td>
                      <td>{a.clientes}</td>
                      <td>{a.colaborador}</td>
                      <td>{a.cajero}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total_cantidad)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general)}</td>
                      <td>{a.condPago}</td>
                      <td>{a.numeroFactura}</td>
                      <td>{a.cajaNombre}</td>
                      <td>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.fechaHora,
                                  a.colaborador,
                                  a.clientes,
                                  a.consecutivo,
                                  a._id,
                                  a.comisionTDC,
                                  a.comisionFlete,
                                  a.impuestos,
                                  a.areaSurtido,
                                  a.descuento,
                                  a.descuentoNumero,
                                  a.condPago,
                                  a.idAreas,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.descuentoTipo,
                                  a.cajero,
                                  a.cajaNombre,
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                            {user.ventasTiendasCancel?(
                              
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => cancelarNota(a._id)}
                            >
                              <i class="fas fa-ban"></i>
                            </Button>
                            ):undefined}
                      </td>
                    
                    </tr>
                  );
                }else{
                  return (
                    <tr className="row-cancelled">
                      <td>{a.consecutivo}</td>
                      <td>{a.numero}</td>
                      <td>{a.area}</td>
                      <td>{formatDate(a.fecha)}</td>
                      <td>{a.fechaLiquidacion ? formatDate(a.fechaLiquidacion) : ""}</td>
                      <td>{a.clientes}</td>
                      <td>{a.colaborador}</td>
                      <td>{a.cajero}</td>
                      <td></td>
                      <td></td>
                      <td>CANCELADA </td>
                      <td></td>
                      <td>{a.cajaNombre}</td>
                      <td>  <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.fechaHora,
                                  a.colaborador,
                                  a.clientes,
                                  a.consecutivo,
                                  a._id,
                                  a.comisionTDC,
                                  a.comisionFlete,
                                  a.impuestos,
                                  a.areaSurtido,
                                  a.descuento,
                                  a.descuentoNumero,
                                  a.condPago,
                                  a.idAreas,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.descuentoTipo,
                                  a.cajero,
                                  a.cajaNombre,
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button></td>
                  </tr>
                  )
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="right">
                  TOTALES
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalCant)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalGen)}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

     
      {loader}
    </>
  );
}

export default ListadoVentasTiendas;
